import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';
import { MarketplaceArche } from '@/lib/api';

interface CurrentArcheItemProps {
  arche: MarketplaceArche;
}

export function CurrentArcheItem({ arche }: CurrentArcheItemProps) {
  return (
    <div className="mx-2 my-2 rounded-lg bg-linear-to-r from-primary/15 via-primary/10 to-primary/5 border border-primary/30 shadow-sm">
      <div className="px-3 py-3">
        <div className="flex items-start gap-2.5">
          {arche.imageRef ? (
            <img
              src={arche.imageRef}
              alt={arche.name}
              className="w-9 h-9 rounded-lg object-cover flex-shrink-0 shadow-sm"
            />
          ) : (
            <div className="w-9 h-9 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0 shadow-sm">
              <span className="text-sm font-semibold text-primary">{arche.name.charAt(0)}</span>
            </div>
          )}
          <div className="min-w-0 flex-1">
            <div className="font-semibold text-sm text-primary line-clamp-2">{arche.name}</div>
            <div className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
              {arche.simpleDescription}
            </div>
          </div>
        </div>
        <Link
          to={`/marketplace/arches/${arche.archId}`}
          className="inline-flex items-center gap-1 mt-2 ml-[2.875rem] text-xs text-primary/70 hover:text-primary transition-colors"
        >
          <Info className="h-3 w-3" />
          <span>Info</span>
        </Link>
      </div>
    </div>
  );
}

export default CurrentArcheItem;
